import gql from "graphql-tag"

const fragment = gql`
  fragment fullRegion on Region {
    id
    name
    metadata {
      createdAt
    }
    description
    homepageId
    homepageCategoryId
    termsAndConditionsUrl
    paymentCountryCode
    state
  }
`

export const toString = fragment.loc.source.body

export default fragment
